import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getColor } from '@/helpers/utils';
 
// جهت نمایش پروتوکل در جدول
type ProtocolRendererProps = {
  protocol?: string | null;
};

const ProtocolRenderer = ({ protocol }: ProtocolRendererProps) => {
  return (
    <>
      {protocol && (
        <div className="d-flex gap-1 align-items-baseline">
          <span>{protocol}</span>
          <FontAwesomeIcon
            size="sm"
            title={protocol}
            icon={protocol === 'http' ? 'lock-open' : 'lock'}
            color={
              protocol === 'http' ? getColor('danger') : getColor('success')
            }
          >
          </FontAwesomeIcon>
        </div>
      )}
    </>
  );
};

export default ProtocolRenderer;
